import { useLocalStorage } from "@vueuse/core"
import { computed } from "vue"

/** localStorage key holding the ISO timestamp the modal was last dismissed at. */
export const YOU_WON_DISMISSED_AT_KEY = "so-rewarding-you-won-dismissed-at"

const WEEK_MS = 7 * 24 * 60 * 60 * 1000
/** After a dismiss, suppress the modal for this long. */
const SUPPRESS_WINDOW_MS = 5 * WEEK_MS

/**
 * Tracks whether the So Rewarding "you won" modal was dismissed within the last
 * 5 weeks. Standalone (not inside useYouWonModal) so it can gate the
 * loyalty-status fetch — we skip the call entirely while suppressed, before the
 * data the modal needs is requested.
 */
export function useYouWonSuppression() {
  // flush sync so the dismiss persists before a possible immediate refresh
  const dismissedAt = useLocalStorage(YOU_WON_DISMISSED_AT_KEY, "", {
    flush: "sync",
  })

  const isSuppressed = computed(() => {
    const dismissedTs = dismissedAt.value
    if (!dismissedTs) return false
    return Date.now() - new Date(dismissedTs).getTime() < SUPPRESS_WINDOW_MS
  })

  function dismiss() {
    dismissedAt.value = new Date().toISOString()
  }

  return { isSuppressed, dismiss }
}
